import type { BadgeProps, ClipboardRootProps } from '@chakra-ui/react';
import { Badge, Text } from '@chakra-ui/react';
import React from 'react';
import { ClipboardIconButton, ClipboardRoot } from '@/components/ui/clipboard';

interface ClipboardBadgeProps extends ClipboardRootProps {
  value: string;
  badgeProps?: BadgeProps;
  children?: React.ReactNode;
}

export const ClipboardBadge: React.FC<ClipboardBadgeProps> = ({
  value,
  children,
  badgeProps,
  ...props
}) => (
  <ClipboardRoot value={value} {...props}>
    <Badge {...badgeProps}>
      {children ? <Text as="span">{children}</Text> : <Text as="span">{value}</Text>}
      <ClipboardIconButton unstyled cursor="pointer" />
    </Badge>
  </ClipboardRoot>
);

export default ClipboardBadge;
